import React from 'react'
import {
    Alert,
    TextAlert,
    IconAlert
} from './style'

export default function AlertInline({ text, textFontSize }) {
    return (
        <Alert>
            <IconAlert className="mdi mdi-alert" />
            <TextAlert textFontSize={textFontSize}>
                {text}
            </TextAlert>
        </Alert>
    )
}
